import { LockedBlurredListOverlay, LockedEmptyUpsell } from '../shared/LockedPlanPieces'
import { ALLOCATION_BLURRED_CATEGORIES } from '../../../../../mock/data/blurFixtures'
import { useLumpsumPlansContext } from '../../LumpsumPlansProvider'
import { AllocationCategoryList } from './AllocationCategoryList'

/** PLAN_ROLLED_OUT but not Prime. */
export function AllocationBlurredBody() {
  const { allocationPlansData } = useLumpsumPlansContext()
  const sellFundCount = allocationPlansData?.sellFundCount ?? 0
  const buyFundCount = allocationPlansData?.buyFundCount ?? 0
  const underReviewFundCount = allocationPlansData?.underReviewFundCount ?? 0
  const hasLockedListContent = sellFundCount + buyFundCount + underReviewFundCount > 0

  if (!hasLockedListContent) {
    return (
      <LockedEmptyUpsell
        copy="Get Allocation Plan, SIP Plan, Rebalance Plan,<br />Where to invest, Power Rank, Trends and a lot more."
        buttonLabel="Unlock with Elite Prime"
        landingPage="prime"
      />
    )
  }

  return (
    <LockedBlurredListOverlay
      message={
        <>
          Your allocation plan is
          <br />
          currently locked
        </>
      }
      buttonLabel="Unlock with Prime"
      landingPage="prime"
    >
      <AllocationCategoryList categories={ALLOCATION_BLURRED_CATEGORIES} />
    </LockedBlurredListOverlay>
  )
}
